import { v4 as uuidv4 } from 'uuid';
import mock from '../config/mock';

mock.onGet('/api/bookings').reply(200, {

    bookings: [
        {
            id: uuidv4(),
            slot: '5',
            day: 'Tuesday',
            starttime: '2020-01-01 00:00:00',
            endtime: '2020-01-01 00:00:00',
        },
        {
            id: uuidv4(),
            slot: '3',
            day: 'Monday',
            starttime: '2020-01-01 00:00:00',
            endtime: '2020-01-01 00:00:00',
        },
        {
            id: uuidv4(),
            slot: '5',
            day: 'Saturday',
            starttime: '2020-01-01 00:00:00',
            endtime: '2020-01-01 00:00:00',
        }
       
    ]
});

mock.onGet('/api/bookingdetails/1').reply(200, {

    bookingdetails: [
        {
            name: 'asd',
            email: 'asd@asd.com',
            contact: '0987654321',
            position: 'asd'
        },
    ]
});